import { useEffect, useState } from 'react';
import './central.css';

/**
 * FOTO DO PRODUTO nas divergências (dono, 29/09: "faltando laboratório e foto"). A mesma foto do
 * Giro (InovaPED, casada só por EAN exato). Sem foto — ou foto que não carrega — vira um quadrado
 * "SEM FOTO", nunca ícone quebrado.
 */
export function FotoDoProduto({
  url,
  nome,
  tamanho,
}: {
  url: string | null;
  nome: string;
  tamanho: number;
}) {
  const [falhou, setFalhou] = useState(false);
  useEffect(() => setFalhou(false), [url]);
  return (
    <span className="dv-foto" style={{ width: tamanho, height: tamanho, flexBasis: tamanho }}>
      {url && !falhou ? (
        <img src={url} alt={`Foto de ${nome}`} loading="lazy" onError={() => setFalhou(true)} />
      ) : (
        <em>SEM FOTO</em>
      )}
    </span>
  );
}
